import * as types from './actionTypes';
import feedbackDataApi from './api';

const fetchFeedbackDataStart = () => {
  return {
    type: types.FETCH_DATA_REQUEST,
  };
};

const fetchFeedbackDataDone = payload => {
  return {
    type: types.FETCH_DATA_SUCCESS,
    payload,
  };
};

const fetchFeedbackDataFail = payload => {
  return {
    type: types.FETCH_DATA_FAILURE,
    payload,
  };
};

export const fetchFeedbackData = id => dispatch => {
  dispatch(fetchFeedbackDataStart());

  return feedbackDataApi
    .getFeedbackData(id)
    .then(data => dispatch(fetchFeedbackDataDone(data)))
    .catch(({ message }) => dispatch(fetchFeedbackDataFail(message)));
};

//

const sendFeedbackDataStart = () => {
  return {
    type: types.SEND_DATA_REQUEST,
  };
};

const sendFeedbackDataDone = () => {
  return {
    type: types.SEND_DATA_SUCCESS,
  };
};

const sendFeedbackDataFail = payload => {
  return {
    type: types.SEND_DATA_FAILURE,
    payload,
  };
};

export const sendFeedback = formValues => dispatch => {
  dispatch(sendFeedbackDataStart());

  return feedbackDataApi
    .sendFeedbackData(formValues)
    .then(data => dispatch(sendFeedbackDataDone(data)))
    .catch(({ message }) => dispatch(sendFeedbackDataFail(message)));
};

//

export const resetFeedback = () => {
  return {
    type: types.RESET_FEEDBACK,
  };
};
